import React, { useState } from 'react';
import styles from './Tabs.module.css';
import Description from './../Description/Description'
import Dimensions from './../Dimensions/Dimensions';
import Instructions from './../Instructions/Instructions';

const Tabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = ['Descriere', 'Dimensiuni', 'Instrucțiuni'];
  return (
    <div className={styles.tabContainer}>
      {props.tabsInfo &&
        (<>
          <div className={styles.tabHeader}>
            {
              props.tabsInfo.map((el, index) => {
                if (el) {
                  return <button
                    key={index}
                    className={`${styles.tab} ${activeTab === index ? styles.activeTab : ''
                      }`}
                    onClick={() => setActiveTab(index)}
                  >
                    {tabs[index]}
                  </button>
                }
              })
            }
          </div>
          <div className={styles.tabContent}>
            {activeTab === 0 && <Description productId={props.productId} />}
            {activeTab === 1 && <Dimensions productId={props.productId} />}
            {activeTab === 2 && <Instructions productId={props.productId} />}
          </div>
        </>)}
    </div>
  );
};

export default Tabs;
